if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        pagination: '.swiper-pagination',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;
      this.columnsDesktop = this.dataset.columnsDesktop;
      this.columnsMobile = this.dataset.columnsMobile;
      this.staticNav = this.dataset.staticNav === 'true';

      this.sliderInstance = false;

      this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      this.insertDesktopImages = this.insertDesktopImages.bind(this);
      this.insertDesktopImages();
      if (this.querySelector('[data-desktop-image]')) {
        this.mql.addEventListener('change', this.insertDesktopImages);
      }

      if ('IntersectionObserver' in window && !Shopify.designMode) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.init();
          },
          { rootMargin: '200px 0px' }
        );
        this.observer.observe(this);
      } else {
        this.init();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mql?.removeEventListener('change', this.insertDesktopImages);
    }

    init() {
      this.initSlider();
    }

    insertDesktopImages() {
      if (this.mql.matches) return;
      this.querySelectorAll('[data-desktop-image]').forEach((placeholder) => {
        placeholder.insertAdjacentHTML('afterend', placeholder.dataset.desktopImage);
        placeholder.remove();
      });
      this.mql.removeEventListener('change', this.insertDesktopImages);
    }

    initSlider() {
      const enablePagination = this.staticNav;

      const parsedColumnsMobile = parseInt(this.columnsMobile || '0', 10);
      const mobileColumns = Number.isNaN(parsedColumnsMobile) || parsedColumnsMobile <= 0 ? 2 : parsedColumnsMobile;
      const mobileSlidesPerView =
        this.itemSize === 'fixed'
          ? mobileColumns > 4
            ? 'auto'
            : mobileColumns
          : 'auto';

      const sliderOptions = {
        modules: enablePagination
          ? [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel]
          : [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Mousewheel],
        slidesPerView: mobileSlidesPerView,
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            spaceBetween: this.cardStyle == 'card' ? 20 : 20,
            slidesPerView: this.itemSize == 'fixed' ? (this.columnsDesktop > 4 ? 4 : this.columnsDesktop) : 'auto',
          },
          1024: {
            spaceBetween: this.cardStyle == 'card' ? 20 : 20,
            slidesPerView: this.itemSize == 'fixed' ? this.columnsDesktop : 'auto',
          },
          1280: {
            spaceBetween: this.cardStyle == 'card' ? 20 : 20,
            slidesPerView: this.itemSize == 'fixed' ? this.columnsDesktop : 'auto',
          },
        },
      };

      if (enablePagination) {
        sliderOptions.pagination = {
          el: this.section.querySelector(this.selectors.pagination),
          type: 'fraction',
        };
      }

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}
